import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DataShareService {

  private _dataSource = new Subject();

  dataSource = this._dataSource.asObservable()
  constructor() { }

  send(data: any) {
    this._dataSource.next(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/data-share.service.ts